export default function Topbar({ onMenuClick }) {
  return (
    <header className="topbar">
      <button className="menu-btnsidebarD" onClick={onMenuClick}>
        ☰
      </button>

      <div className="topbar-center">
        {/* <select>
          <option>Categories</option>
        </select>
        <button className="courses-btn buttonDashB">All Courses</button> */}
      </div>

      <div className="cart">🛒 <span>4</span></div>
    </header>
  );
}
